export const managersPageTranslations = {
    en: {
        search_name_placeholder: "Search by name",
        location_placeholder: "Location",
        manager_type_placeholder: "Manager Type",
        status_placeholder: "Status",
        reset_filters_tooltip: "Reset all filters",
        table_column_gender: "Gender",
        loading_text: "Loading...",
        error_countries: "Failed to load countries",
        error_managers: "Failed to load managers",
        Male: "Male",
        Female: "Female",
        Others: "Others",
        gender_placeholder: "Gender",
        table_column_manager: "Manager",
        table_column_phone: "Phone",
        table_column_location: "Location",
        table_column_region: "Region",
        table_column_type: "Type",
        table_column_organization: "Organization",
        table_column_verified: "Verified",
        table_column_status: "Status",
        table_column_actions: "Actions",
        table_empty_content: "No managers found",
        edit_manager_tooltip: "Edit manager",
        pagination_showing: "Showing {start} to {end} of {total} managers",
        all_locations: "All Locations",
        all_types: "All Types",
        all_status: "All Status",
        yes: "Yes",
        no: "No",
        na: "N/A",
        agency: "Agency",
        individual: "Individual",
    },
    de: {
        search_name_placeholder: "Nach Namen suchen",
        location_placeholder: "Standort",
        manager_type_placeholder: "Manager-Typ",
        gender_placeholder: "Geschlecht",
        status_placeholder: "Status",
        reset_filters_tooltip: "Alle Filter zurücksetzen",
        loading_text: "Laden...",
        table_column_gender: "Geschlecht",
        Male: "Männlich",
        Female: "Weiblich",
        Others: "Andere",
        error_countries: "Länder konnten nicht geladen werden",
        error_managers: "Manager konnten nicht geladen werden",
        table_column_manager: "Leiter",
        table_column_phone: "Telefon",
        table_column_location: "Standort",
        table_column_region: "Region",
        table_column_type: "Typ",
        table_column_organization: "Organisation",
        table_column_verified: "Verifiziert",
        table_column_status: "Status",
        table_column_actions: "Aktionen",
        table_empty_content: "Keine Manager gefunden",
        edit_status_tooltip: "Status bearbeiten",
        pagination_showing: "Zeigt {start} bis {end} von {total} Managern",
        all_locations: "Alle Standorte",
        all_types: "Alle Typen",
        edit_manager_tooltip: "Manager bearbeiten",
        all_status: "Alle Status",
        yes: "Ja",
        no: "Nein",
        na: "N/V",
        agency: "Agentur",
        individual: "Einzeln",
    },
    hr: {
        search_name_placeholder: "Pretraži po imenu",
        location_placeholder: "Lokacija",
        manager_type_placeholder: "Vrsta managera",
        status_placeholder: "Status",
        reset_filters_tooltip: "Poništi sve filtre",
        loading_text: "Učitavanje...",
        table_column_gender: "Spol",
        gender_placeholder: "Spol",
        error_countries: "Neuspjelo učitavanje zemalja",
        error_managers: "Neuspjelo učitavanje managera",
        table_column_manager: "Menadžer",
        table_column_phone: "Telefon",
        table_column_location: "Lokacija",
        Male: "Muško",
        Female: "Žensko",
        Others: "Ostalo",
        table_column_region: "Regija",
        table_column_type: "Vrsta",
        table_column_organization: "Organizacija",
        table_column_verified: "Potvrđeno",
        table_column_status: "Status",
        table_column_actions: "Akcije",
        table_empty_content: "Nema pronađenih managera",
        edit_status_tooltip: "Uredi status",
        pagination_showing: "Prikazujem {start} do {end} od {total} managera",
        all_locations: "Sve lokacije",
        all_types: "Sve vrste",
        edit_manager_tooltip: "Uredi menadžera",
        all_status: "Svi statusi",
        yes: "Da",
        no: "Ne",
        na: "N/A",
        agency: "Agencija",
        individual: "Pojedinac",
    }

};
